import { Box } from '@mui/material';
import React from 'react';
import { HorizontalStack, SmartContainer } from '../../../styles/Containers';
import { StyledP } from '../../../styles/StyledHTML';
export const IconSuggestion = ({ icon, label }) => {
    return (
        <HorizontalStack width="100%" flex align="center">
            {icon}
            &nbsp;
            &nbsp;
            {label}
        </HorizontalStack>
    )
}

export const IconSuggestionBox = ({ icon, label, option, ...rest }) => {
    return (<Box component="li" {...rest}><IconSuggestion icon={icon} label={label} /></Box>)
}